import{
    SET_USERS_LIST,
    SET_USERS_ACTIVE_SCREEN,
    SET_OPEN_EDIT_USER_MODAL,
    SET_CLOSE_EDIT_USER_MODAL,
    SET_ROLE_LIST,
    SET_IS_GET_USER_ROLE_LIST_PENDING,
    SET_IS_EDIT_ROLE_PENDING,
} from "../constants/users.constants"

const initialState: eventsState = {
    usersList: null,
    activeScreen: 0,
    isEditUser: false,
    roleList: null,
    isGetUserRoleListPending: false,
    isEditUserRolePending: false,
};

export default (
    localState: eventsState = initialState,
    action: Action
): eventsState => {
    switch(action.type)
    {
        case SET_USERS_LIST: {
            return {
                ...localState,
                usersList: action.payload,
            };
        }

        case SET_USERS_ACTIVE_SCREEN:{
            return{
                activeScreen: action.payload,
            }
        }
        case SET_CLOSE_EDIT_USER_MODAL:{
            return{
                ...localState,
                isEditUser: false,
            }
        }
        case SET_OPEN_EDIT_USER_MODAL:{
            return{
                ...localState,
                isEditUser: true,
            }
        }

        case SET_ROLE_LIST: {
            return{
                ...localState,
                roleList: action.payload,
            }
        }

        case SET_IS_GET_USER_ROLE_LIST_PENDING: {
            return{
                ...localState,
                isGetUserRoleListPending: action.payload,
            }
        }

        case SET_IS_EDIT_ROLE_PENDING: {
            return{
                ...localState,
                isEditUserRolePending: action.payload,
            }
        }

        default: {
            return localState;
        }
    }
}